import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  /* ================= PAGE WRAPPER ================= */
  .event-page {
    .event-page-area {
      padding: 70px 0;

      @media (max-width: 767px) {
        padding: 40px 0 35px;
      }
    }
  }

  /* ================= MODERN EVENT CARD ================= */
  .modern-event-card {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
    overflow: hidden;
    transition: all 0.35s ease;
    height: 100%;
  }

  .modern-event-card:hover {
    transform: translateY(-8px) rotate(-1deg);
  }

  /* ================= IMAGE ================= */
  .event-image-wrapper {
    position: relative;
    width: 100%;
    height: 300px; /* fixed height */
    background: #f3f3f3;
    overflow: hidden;
  }

  .event-image-wrapper img {
    width: 360px;     /* fixed width */
    height: 300px;    /* fixed height */
    object-fit: cover;
    display: block;
    margin: 0 auto;
  }

  /* ================= DATE BADGE ================= */
  .event-date-badge {
    position: absolute;
    top: 16px;
    left: 16px;
    background: #ffffff;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    color: ${colors.green};
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.18);
    z-index: 2;
    text-transform: uppercase;
  }

  /* ================= CARD BODY ================= */
  .event-card-body {
    padding: 22px;
  }

  .event-category {
    display: inline-block;
    background: rgba(30, 136, 229, 0.12);
    color: #1e88e5;
    font-size: 12px;
    padding: 5px 12px;
    border-radius: 6px;
    margin-bottom: 12px;
    font-weight: 600;
  }

  .event-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 12px;
    line-height: 1.35;
  }

  .event-title a {
    color: ${colors.black1};
    text-decoration: none;
  }

  .event-title a:hover {
    color: ${colors.green};
  }

  /* ================= META ================= */
  .event-meta {
    list-style: none;
    padding: 0;
    margin: 0 0 12px;
    font-size: 13px;
    color: ${colors.text3};
  }

  .event-meta li {
    margin-bottom: 6px;
  }

  .event-meta i {
    color: ${colors.green};
    margin-right: 6px;
    font-size: 15px;
    vertical-align: middle;
  }

  /* ================= DESCRIPTION ================= */
  .event-desc {
    font-size: 14px;
    color: ${colors.text2};
    line-height: 21px;
    margin-bottom: 18px;
  }

  /* ================= ACTION ================= */
  .event-actions {
    display: flex;
    justify-content: flex-end;
  }

  .btn-view {
    background: ${colors.green};
    color: #ffffff;
    padding: 9px 16px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.25s ease;
  }

  .btn-view:hover {
    background: #128b4c;
    color: #ffffff;
  }

  /* ================= RESPONSIVE ================= */
  @media (max-width: 991px) {
    .event-image-wrapper {
      height: 360px;
    }

    .event-image-wrapper img {
      width: 100%;
      height: 360px;
    }
  }

  @media (max-width: 575px) {
    .event-image-wrapper {
      height: 320px;
    }

    .event-image-wrapper img {
      height: 320px;
    }
  }

  /* ================= PAGINATION (UNCHANGED) ================= */
  ul.pagination-box {
    margin-top: 30px;

    li {
      margin-right: 15px;

      a {
        font-size: 16px;
        color: ${colors.green};
        width: 38px;
        height: 38px;
        border: 1px solid ${colors.border3};
        background-color: #fff;
        display: block;
        padding-top: 7px;
        border-radius: 50%;
        cursor: pointer;

        &:hover {
          background-color: ${colors.green};
          color: #ffffff;
          border-color: ${colors.green};
        }

        @media (max-width: 575px) {
          font-size: 14px;
          width: 30px;
          height: 30px;
          padding-top: 4px;
        }
      }

      &:last-child {
        margin-right: 0;
      }
    }

    li.active {
      a {
        background-color: ${colors.green};
        color: #fff;
        border-color: ${colors.green};
      }
    }

    @media (max-width: 767px) {
      margin-top: 20px;
    }
  }
`;
